/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_Geo_AuditInputs */

const en_directory_submit_enrich_stage_geo_audit = /** @type {(inputs: Directory_Submit_Enrich_Stage_Geo_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO audit`)
};

const zh_directory_submit_enrich_stage_geo_audit = /** @type {(inputs: Directory_Submit_Enrich_Stage_Geo_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO 审计`)
};

/**
* | output |
* | --- |
* | "GEO audit" |
*
* @param {Directory_Submit_Enrich_Stage_Geo_AuditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_geo_audit = /** @type {((inputs?: Directory_Submit_Enrich_Stage_Geo_AuditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_Geo_AuditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_geo_audit(inputs)
	return zh_directory_submit_enrich_stage_geo_audit(inputs)
});
export { directory_submit_enrich_stage_geo_audit as "directory.submit.enrich.stage.geo_audit" }